import React from "react";
import { Card, CardBody, CardHeader } from "shards-react";
import { Doughnut } from 'react-chartjs-2';
const options = {
  responsive: true,
  maintainAspectRatio: true,
  legend: {
    position: "bottom",
    labels: {
      padding: 25,
      boxWidth: 20
    }
  },
  tooltips: {
    custom: false,
    mode: "index",
    position: "nearest"
  }
}

export default class DoughnutChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      data: this.props.data,
      increase: this.props.increase,
      total: this.props.total,
      percentage: this.props.percentage,
    }
  }

  render() {
    const { title, data } = this.state;
    return (
      <Card className="mb-4 card-custom h-100 ">
        <CardHeader className="card-charts-title">
          <h6 className="text-grey select-none">{title}</h6>
          <select className='form-control'>
            <option value="europe">Europe</option>
            <option value="america">America</option>
            <option value="asia">Asia</option>
            <option value="africa">Africa</option>
            <option value="australia">Australia</option>
          </select>
        </CardHeader>
        <CardBody className="pie-charts-box">
          <div className="charts-pie-wrapper">
            <Doughnut data={data} options={options} />
          </div>

        </CardBody>
      </Card>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashChartsComponent/doughnutCharts.js